import { Injectable } from '@angular/core';

import { ScheduledBooking } from '../../models/scheduled-booking';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class ScheduledBookingService {
  /**
   * A service providing access to scheduled bookings via the API.
   */

  constructor(
    private apiService: ApiService
  ) {}

  /**
   * Get information on the given scheduled booking.
   */
  getScheduledBooking(bookingId: number): Promise<ScheduledBooking> {
    return this.apiService.getFromAPI<ScheduledBooking>(
      'gym-endpoints/get-booking/' + bookingId.toString() + '/'
    );
  }

  /**
   * Cancel reservations and/or give refunds (partial or full) for the given
   * booking.
   */
  manageBookingCancellationAndRefund(
    bookingId: number,
    reservationIdsToCancel: number[],
    refundCurrencyAmount: number,
    refundVoucherCount: number,
    sendCancellationEmails: boolean,
    cancellationEmailText: string
  ): Promise<void> {
    const body: any = {
      reservation_ids: reservationIdsToCancel.join(','),
      refund_currency_amount: refundCurrencyAmount,
      refund_voucher_count: refundVoucherCount,
      send_cancellation_emails: sendCancellationEmails,
      cancellation_email_text: cancellationEmailText
    };

    return this.apiService.postToAPI<any>(
      'gym-endpoints/manage-booking-cancellation-and-refund/' + bookingId.toString() + '/',
      body
    ).then();
  }

  rebook(
    bookingId: number,
    newEventId: number,
    rebookingEmailText: string
  ): Promise<void> {
    return this.apiService.postToAPI<any>(
      'gym-endpoints/rebook/' + bookingId.toString() + '/' + newEventId.toString() + '/',
      {
        rebooking_email_text: rebookingEmailText
      }
    ).then();
  }
}
